'use client';

import { useParams } from 'next/navigation';

import {
  EmptyCalendarState,
  GiftCardDetails,
  GiftCardDetailsSkeleton,
  PageContainer,
} from '@/components';
import { useGiftCard } from '@/state/gift-cards';
import { useNotFoundRedirect } from '@/hooks/use-not-found-redirect';
import { useProductViewTracking } from '@/hooks/use-product-view-tracking';

const GiftCardData = () => {
  const params = useParams();
  const slug = params.slug as string;

  const { data: giftCard, isLoading, error } = useGiftCard({ slug });
  const isGone = useNotFoundRedirect(error, '/gift-cards');

  useProductViewTracking({
    type: 'gift_card',
    id: giftCard?.gift_card_id,
    slug: giftCard?.slug ?? '',
    name: giftCard?.name ?? '',
    price: giftCard?.price ?? null,
    currency: giftCard?.currency ?? null,
  });

  if (isLoading) {
    return <GiftCardDetailsSkeleton />;
  }

  if (isGone) {
    return null;
  }

  if (giftCard) {
    return <GiftCardDetails giftCard={giftCard} />;
  }

  return (
    <PageContainer className="ground-empty-state flex items-center justify-center">
      <EmptyCalendarState
        title="We couldn't load this gift card"
        description="Please try again."
      />
    </PageContainer>
  );
};

export default GiftCardData;
